export enum EntityType {
  Availability = 'availability',
  Property = 'property',
  LeaseComp = 'lease',
  SaleComp = 'sale',
  PortfolioSale = 'portfoliosale',
  Company = 'company',
  Contact = 'contact',
  Tim = 'tim',
  Tenancy = 'tenancy',
  Brand = 'brand',
  Complex = 'complex',
  Tenants = 'tenants',
}
